
export const getChannelListData = ({
  data,
  currentUser,
  setChannelList,
  setCategory,
  setChannel,
  fetchEndUsers,
  setViewChannel,
}) => {
  const items = data.map((item) => {
    if (item.type !== "Inactive") {
      return { value: item.idCustomer, label: item.name };
    }
    return null;
  }).filter(Boolean);

  if (currentUser.idCustomer === "HP") {
    setChannelList(items);
    setCategory(2);
  } else {
    const channelSelect = items.filter((x) => x.value === currentUser.idCustomer);
    setChannelList(channelSelect);
    setChannel([channelSelect[0].value]);
    fetchEndUsers(currentUser.idCustomer);
    setCategory(1);
    setViewChannel(true);
  }
};

export const getEndUserListData = ({
  data,
  setEndUserList,
  setEndUserListCombineClicks,
}) => {
  const items = data
    .filter((item) => {
      const numerosFiltrados = item.pressList
        .split(",")
        .map((num) => num.trim())
        .filter((num) => parseInt(num.charAt(0), 10) >= 4);
      return numerosFiltrados.length > 0;
    })
    .map((item) => ({
      value: item.idEndUser,
      label: item.endUserName,
    }));

  setEndUserList(items);
  setEndUserListCombineClicks(items);
};

export const getPressListData = ({
  data,
  setSegmentFlag,
  setPressListBySeries,
  setSegment,
  setSegmentSelected,
  setSeriesList,
  setSerieFix,
  setSeries,
  fetchSpConditions,
}) => {
  const filterData = data.filter((item) => item.series >= 3);

  if (filterData.length === 0) setSegmentFlag(true);

  setPressListBySeries(filterData);

  for (let i = 0; i < filterData.length; i++) {
    Object.assign(filterData[i], { uid: i, rowConfig: { selected: false } });
  }

  if (filterData.length > 0) {
    let array = filterData
      .map((x) => x.segment)
      .filter((x, idx, item) => item.indexOf(x) === idx);

    if (array.length === 1) {
      setSegment(array);
      setSegmentSelected(array[0].segment);
      setSegmentFlag(true);

      let array2 = filterData
        .map((x) => x.series)
        .filter((x, idx, item) => item.indexOf(x) === idx)
        .map((x) => ({ value: x, label: x }));

      setSeriesList(array2);

      if (array2.length === 1) {
        if (array2[0].value >= 3) setSerieFix([array2[0].value]);
        else setSeries([array2[0].value]);

        if (array2[0].value >= 3 && array.length === 1) {
          fetchSpConditions(array2[0].value);
        }
      } else {
        setSeries("");
      }
    } else {
      setSegment([]);
      setSegmentFlag(false);
      setSegmentSelected("");
    }
  } else {
    setSeriesList([]);
  }
};

export const getSpConditionListData = ({ data, setSpecialConditionTypeList, setSpecialConditionType }) => {
  const items = data.map((item) => ({
    value: item.idSpecialConditionType,
    label: item.specialConditionType,
  }));

  if (items.length === 1) setSpecialConditionType([items[0].value]);
  setSpecialConditionTypeList(items);
};

export const getConfigPressData = ({
  data,
  setOneShotDisabled,
  setWhiteDisabled,
  setMultiplierConfig,
  setWhiteCpp,
  t,
  Swal,
}) => {
  if (data.length > 0) {
    setOneShotDisabled(!data[0].oneShotVisible);
    setWhiteDisabled(!data[0].whiteVisible);
    setMultiplierConfig(data[0].multiplier);
    setWhiteCpp("");
  } else {
    Swal.fire("Error ", t("Error_S4"), "error");
  }
};

